import { combineReducers, createReducer } from "@reduxjs/toolkit";

import {
	dataEtfsLoaded,
	dataLoadingComplete,
	filterSet,
	filterInputSetSelectFieldValue,
	filterInputSetNumberRangeFieldValue,
	preferenceSetCurrency,
	dataFilteredEtfsSet,
	preferenceSetConcreteEtfs
} from "./actions";
import {  } from "../fields";
import {
	ScreenerStore,
	ScreenerStoreData,
	ScreenerStoreFilter,
	ScreenerStoreFilterNumberRangeInput,
	ScreenerStoreFilterSelectInput,
	ScreenerStorePreference
} from "./model";

const dataReducer = createReducer<ScreenerStoreData>(
	{ isLoaded: false, etfs: [], filteredEtfs: [] },
	builder => builder
		.addCase(dataEtfsLoaded, (state, action) => { state.etfs = action.payload; })
		.addCase(dataFilteredEtfsSet, (state, action) => { state.filteredEtfs = action.payload })
		.addCase(dataLoadingComplete, (state, _) => { state.isLoaded = true }));

const filterReducer = createReducer<ScreenerStoreFilter>(
	{ inputs: { } },
	builder => builder
		.addCase(filterSet, (_, action) => action.payload)
		.addCase(filterInputSetSelectFieldValue, (state, action) => {
			const { systemName, value } = action.payload;
			const input = state.inputs[systemName] as ScreenerStoreFilterSelectInput;
			const newInput: ScreenerStoreFilterSelectInput = { ...input, selectedKey: value };
			state.inputs[systemName] = newInput;
		})
		.addCase(filterInputSetNumberRangeFieldValue, (state, action) => {
			const { systemName, value } = action.payload;
			const input = state.inputs[systemName] as ScreenerStoreFilterNumberRangeInput;
			const newInput: ScreenerStoreFilterNumberRangeInput = { ...input, value: value };
			state.inputs[systemName] = newInput;
		})
)

export const preferenceReducer = createReducer<ScreenerStorePreference>(
	{ currency: 'RUB', concreteEtfs: null },
	builder => builder
		.addCase(preferenceSetCurrency, (state, action) => { state.currency = action.payload })
		.addCase(preferenceSetConcreteEtfs, (state, action) => { state.concreteEtfs = action.payload })
)

export const ScreenerStoreReducer = combineReducers<ScreenerStore>({
	data: dataReducer,
	filter: filterReducer,
	preference: preferenceReducer
});